import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import section1Image from './section1.jpg';
import ButtonBase from '@material-ui/core/ButtonBase';


const styles = theme => ({
  root: {
    flex: 1,
    flexWrap: 'wrap-reverse',
    [theme.breakpoints.up('md')]: {
      height: 700,
    },
   
    backgroundColor:theme.palette.primary.main,
    alignItems:'center',
  },
  section1Text:{
    textAlign:'center',
  },
  section1Image: {  
   height:'100%',
   width:'100%'

   
  },
  image: {
    height: 300,
    width: 250,
    [theme.breakpoints.up('md')]: {
      height: 600,
      width: 500,
      float:'right',
    },
  },
  imageWrapper:{
    [theme.breakpoints.down('sm')]: {
     display:'flex',
     justifyContent:'center',
     padding: '10px 0px'
    },
  }

});



function Section1(props) {
  const { classes } = props;

  return (
    <Grid container direction="row" className={classes.root} >
     <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.section1Text}>
          <Typography variant="headline" color="textPrimary" >Miranda Kerr</Typography>
          <Typography variant="subheading" color="textSecondary">
              Fashion model
          </Typography>    
      </Grid>
      <Grid item className={classes.imageWrapper} xs={12} sm={12} md={6} lg={6} xl={6}>
          <ButtonBase className={classes.image}>
             <img src={section1Image} className={classes.section1Image} alt="Miranda kerr" title="Miranda kerr"/>   
          </ButtonBase>
      </Grid>
       
    </Grid>
  );
}

Section1.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Section1);


// WEBPACK FOOTER //
// ./src/component/home/section1.js